import { ReactElement } from 'react'

import { RequireAuth } from 'src/app/core/routes/components/require-auth'

import { RouteObject } from './types'

export function parseIsPrivateRoutes(routes: RouteObject[]): RouteObject[] {
  return routes.map<RouteObject>(route => {
    const children = route.children
      ? parseIsPrivateRoutes(route.children)
      : undefined
    if (route.isPrivate) {
      const El = route.element as ReactElement
      return {
        ...route,
        element: <RequireAuth>{El}</RequireAuth>,
        children,
      } as RouteObject
    } else {
      return {
        ...route,
        children,
      } as RouteObject
    }
  })
}
